import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
const EllipsisTooltip = ({ tooltipText, tooltipId = 'globalTooltip', children })=>{
    const ref = useRef(null);
    const [isHidden, setIsHidden] = useState(true);
    const checkTextOverflow = ()=>{
        const content = ref.current;
        if (content) {
            const isOverflowing = content.scrollWidth > content.offsetWidth;
            setIsHidden(!isOverflowing);
        }
    };
    useEffect(()=>{
        checkTextOverflow();
        window.addEventListener('resize', checkTextOverflow);
        return ()=>{
            window.removeEventListener('resize', checkTextOverflow);
        };
    }, []);
    return /*#__PURE__*/ _jsx("div", {
        "data-tooltip-id": tooltipId,
        "data-tooltip-content": tooltipText,
        "data-tooltip-hidden": isHidden,
        "data-tooltip-place": "top",
        children: /*#__PURE__*/ _jsx("div", {
            className: "table__wrapCell",
            ref: ref,
            children: children
        })
    });
};
export default EllipsisTooltip;
